<template>
  <div class="emptyData_warp">
    <slot></slot>
    <img :src="imgUrl" alt="">
    <h4>暂无数据</h4>
    <slot name="footer"></slot>
    <h6 v-show="showBtn">开始在这里创建您的数据</h6>
    <el-button type="primary" round @click="btnClick" v-show="showBtn">{{ btnText }}</el-button>
  </div>
</template>

<script>
export default {
  name: 'EmptyData',
  props: {
    btnText: {
      type: String,
      default: '新建数据'
    },
    showBtn: {
      type: Boolean,
      default: true
    },
    imgUrl: {
      type: String,
      default: require('../../assets/imgs/NoDocuments.png'),
    }
  },
  data () {
    return {

    };
  },
  created () {

  },
  mounted () {

  },
  methods: {
    btnClick () {
      this.$emit('btnClick')
    }
  }
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/emptyData/index.vue